export class LinksSwagger {
    constructor(data: Partial<LinksSwagger> = {}) {
        Object.assign(this, data);
        
        }
    public id: string = '';
    public link: string = "";
    public enabled: boolean=false;
  }
  